<template>
  <div class="page-container">
    <div class="query-title" v-if="!sourceType">销售计划量签约单查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button v-if="!sourceType">
            <table-button tip="批量提交OA" name="export" @click="submitOa" v-if="btnLimits.submit_oa"/>
            <table-button tip="批量审核" name="export" @click="submitApprove"  v-if="btnLimits.approve"/>
            <table-button tip="批量作废" name="export" @click="submitVoid"  v-if="btnLimits.void"/>
            <table-button tip="变更" name="export" @click="submitChange"  v-if="btnLimits.change"/>
            <table-button tip="导出" name="export" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #plan_cntr_no="{ row }">
              <span class="blue" @click="goOrderDetail(row)">{{ row.plan_cntr_no }}</span>
            </template>
            <template #is_approve="{ row }">
              <span>{{ row.is_approve === '1' ? '是' : '否' }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <el-form ref="form" :model="dialogForm" label-width="90px" :rules="rules">
          <el-row :gutter="24" v-if="(role.ROLE === 'WLY025' || role.ROLE === 'WLYALL') && dialogLable === '审核意见'">
          <!-- <el-row :gutter="24" > -->
            <el-col :lg="8" :md="12">
              <el-form-item label="大区副总审核" prop="zassign" label-width="120px">
                <el-select
                  v-model="dialogForm.zassign"
                  @change="zassignChange($event)"
                  placeholder=""
                  size="mini"
                >
                  <el-option
                    v-for="item in zassignLists"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                    
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" v-if="dialogForm.zassign">
              <el-form-item label="大区副总" prop="assign" label-width="120px">
                <el-select
                  v-model="dialogForm.assign"
                  placeholder=""
                  size="mini"
                  multiple
                  @change="assignBpChange($event)"
                >
                  <el-option
                    v-for="item in deputyLists"
                    :key="item.partner"
                    :label="item.name"
                    :value="item.partner"
                  />
              </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="本次提交情况" v-if="allOrderType" label-width="120px">
            <!-- <el-input type="textarea" class="textareaInput" rows="4" resize="none" v-html="dialogForm.main_contont" disabled></el-input> -->
            <div class="mainContont" v-html="dialogForm.main_contont">

            </div>
          </el-form-item>
          <el-form-item class="content_item" :label="chflText" v-if="dialogLable === '大区意见' && allOrderType==='ZP01'" label-width="120px">
            <div class="title">
              <!-- <p class="left-title">{{ chflText }}</p> -->
              <p class="left-title">签约完成情况</p>
            </div>
            <vxe-grid
              ref="gridOaOption"
              class="table-block oa-table"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="240"
              max-height="500"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOaOption.columns"
              :data="gridOaOption.data"
            >
            </vxe-grid>
          </el-form-item>
          <el-form-item label="特殊说明" v-if="dialogLable === '大区意见' && allOrderType==='ZP01'" label-width="120px">
            <el-input
              v-model="dialogForm.spec_note"
              rows="4"
              type="textarea"
              clearable
              maxlength="2000"
            />
          </el-form-item>
          <el-form-item :label="dialogLable" prop="audit_comment"  label-width="120px">
            <el-input type="textarea" maxlength="2000" rows="3" resize="none" v-model="dialogForm.audit_comment"></el-input>
          </el-form-item>
          <el-form-item  class="classFiles" label="附件" label-width="120px" v-if="this.dialogLable === '大区意见'">
            <div class="uploadBtn">
              <el-upload
                ref="upload"
                action=""
                :on-change="uploadFile"
                :show-file-list="false"
                :auto-upload="false"
              >
                <table-button slot="trigger" name="upload" tip="上传" />
              </el-upload>
              <table-button name="delete" tip="删除" @click="delUpload" />
            </div>
            <vxe-grid
              ref="fileTable"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="240"
              max-height="500"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptionsFile.columns"
              :data="gridOptionsFile.data"
            >
              <!-- <template #toolbar /> -->
              <template #file_name="{ row }">
                <span class="blue" @click="downLoadFile(row)">{{ row.file_name }}</span>
              </template>
            </vxe-grid>
          </el-form-item>
        </el-form>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" :loading="loading" icon="el-icon-circle-close" @click="submitCancle">取消</el-button>
        <el-button type="primary" size="small" :loading="loading" icon="el-icon-circle-check" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getSendOAFiles, getSaleCenerSignCompleted} from '@/api/signing'
import {getSpct, spctOrderPlsp, getCenterFz} from '@/api/sap/signing-sap'
import { apiGetContractList, apiApprove } from '@/api/sap/contract'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/salePlanNewList'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { URLS } from '@/api/baseUrl'
import axios from 'axios'

export default {
  mixins: [tableMixins],
  components: {
    ClientSelect,
  },
  data() {
    return {
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'file_name',
            title: '附件名称',
            slots: { default: 'file_name' }
          },
        ],
        data: [],
      },
      checkAssign: [],
      btnLimits: {
        change: '',
        approve: '',
        cancel: '',
        submit_oa: '',
        void: '',
      },
      chflText: '',
      deputyLists: [],
      clientDialog: false,
      zassignLists: [
        {
          key: 'X',
          value: '是'
        },
        {
          key: '',
          value: '否'
        }
      ],
      approveList: [],
      isOaShow: false,
      dialogLable: '大区意见',
      allOrderType: '',
      dialogForm: {
        main_contont: '',
        audit_comment: '',
        zassign: '',
        assign: [],
        spec_note: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
      rules: {
        audit_comment: [{ required: true, message: '请填写大区意见', trigger: 'change' }],
      },
      pageSearch,
      searchField: {},
      isSetFilter: false,
      totalRecomQy: 0,
      totalRecomPrice: 0,
      totalRealityQy: 0,
      totalRealityPrice: 0,
      showDialog: false,
      dialogTitle: '',
      passArr: [],
      gridOaOption:{
        data:[],
        columns:[
          { field: 'totalClients', title: '客户总数量(家)'},
          { field: 'adviseQty', title: '建议签约量(件)'},
          { field: 'adviseMoney', title: '建议签约金额(万元)'},
          { field: 'signedDown', title: '建议签约量下限(件) '},
          { field: 'signedUp', title: '建议签约量上限(件) '},
          { field: 'signedClients', title: '已签约客户数量(家)'},
          { field: 'signedQty', title: '已签约客户数量(件)'},
          { field: 'signedMoney', title: '已签约金额(万元)'},
          { field: 'clientFinishRatio', title: '客户数量签约完成率(%)'},
          { field: 'signQtyFinishRatio', title: '签约总量完成率(%)'},
        ]
      }
    }
  },
  props: {
    sourceType: {
      type: String,
      default: ''
    },
  },
  computed: {
    isChangeShow(){
      const arr = ['WLY002','WLY014','WLYALL']
      return arr.indexOf(this.role.ROLE) > -1
    },
    isApproveShow(){
      const arr = ['WLY002','WLY013','WLY025','WLYALL']
      return arr.indexOf(this.role.ROLE) > -1
    },
    isRepeal(){
      const arr = ['WLY002','WLYALL']
      return arr.indexOf(this.role.ROLE) > -1
    },
    ...mapGetters(['userInfo', 'role'])
  },
  created() {
    this.initPage(pageConfig)
    if(this.sourceType){
      this.gridOptions.columns[0].type = 'radio'
    }
  },
  methods: {
    submitCancle(){
      this.gridOptionsFile.data = []
      this.checkAssign = []
      this.dialogForm = {
        main_contont: '',
        audit_comment: '',
        zassign: [],
        assign_bp: '',
      },
      this.showDialog = false
    },
    // 上传附件
    uploadFile(file){
      const url = `${URLS.QY_URL}`
      const formData = new FormData()
      formData.append('file', file.raw);
      formData.append('module', 'crm_onlinesigning')
      formData.append('submit', 'Upload')
      axios.post(url, formData).then(res => {
        console.log(`output->res`,res)
        if(res.status - 0 === 200){
          this.gridOptionsFile.data.push({
            file_name: file.name,
            file_addr: res.data.uri,
            ...res.data
          })
        }else{
          return Message.warning(res.statusText)
        }
      })
    },
    // 删除附件
    delUpload(){
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      // const url = `${URLS.QY_DELEURL}`
      // const formData = new FormData()
      checkedList.forEach(file => {
        this.gridOptionsFile.data.forEach((ele,idx) => {
          if(ele.uri === file.uri){
            this.gridOptionsFile.data.splice(idx,1)
          }
        });
      });
      //   formData.append('uri', file.uri);
      //   formData.append('submit', 'Delete')
      //   axios.post(url, formData).then(res => {
      //     console.log(`output->res`,res)
      //     // if(res.status - 0 === 200){
      //       // this.gridOptionsFile.data.push(res.data)
      //       this.gridOptionsFile.data.forEach((ele,idx) => {
      //         if(ele.uri === file.uri){
      //           this.gridOptionsFile.data.splice(idx,1)
      //         }
      //       });
      //     // }else{
      //     //   return Message.warning(res.statusText)
      //     // }
      //   })
      // });
      
    },
    assignBpChange(list){
      this.checkAssign = []
      list.forEach(ele => {
        this.deputyLists.forEach(item => {
          if(ele === item.partner){
            this.checkAssign.push(item)
          }
        });
      });
    },
    zassignChange(e){
      this.dialogForm.assign = []
    },
    async getCenterFz(data, type = ''){
      const params = {
        user_bp: this.role.USER_BP,
        sal_center: [{
          high: "",
          low: data.sal_center,
          option: "EQ",
          sign: "I",
        }], 
      }
      // if(!type){
      //   params.partner = [{
      //     high: "",
      //     low: this.role.USER_BP,
      //     option: "EQ",
      //     sign: "I",
      //   }]
      // }
      const res = await getCenterFz(params)
      this.deputyLists = res.data || []
      if(!type){
        const flag = this.gridOptions.data.some(v => v.sal_center === this.role.deptCode)
        this.isOaShow =  this.role.ROLE === 'WLY013' && flag && this.deputyLists.length === 0 || this.role.ROLE === 'WLYALL'
      }
    },
    async saveData(type, spct_head, files = []){
        this.$refs.form.validate(async(val, err) => {
          if (val) {
            if(this.dialogForm.zassign){
              if(this.dialogForm.assign && this.dialogForm.assign.length === 0){
                return Message.warning('请选择大区副总')
              }
            }else{
              this.dialogForm.assign = []
            }
            // if(this.dialogLable === '大区意见'){
            //   if((this.totalRealityQy - 0 > (this.totalRecomQy-0)*1.1 || this.totalRealityQy - 0 < (this.totalRecomQy-0)*0.9) && !this.dialogForm.spec_note){
            //     return Message.warning('请填写特殊说明')
            //   }
            // }
            let es_submit = []
            files && files.forEach(ele => {
              spct_head.forEach(item => {
                if(ele.planType === item.plan_type){
                  es_submit.push({
                    ...this.dialogForm,
                    file_name: ele.fileName,
                    file_addr: ele.fileUrl,
                    plan_type: ele.planType,
                    total_clients: this.gridOaOption.data[0]?.totalClients || '',
                    signed_clients: this.gridOaOption.data[0]?.signedClients || '',
                    advise_qty: this.gridOaOption.data[0]?.adviseQty || '',
                    advise_money: this.gridOaOption.data[0]?.adviseMoney || '',
                    advise_min_qty: this.gridOaOption.data[0]?.signedDown || '',
                    advise_max_qty: this.gridOaOption.data[0]?.signedUp || '',
                    signed_qty: this.gridOaOption.data[0]?.signedQty || '',
                    signed_money: this.gridOaOption.data[0]?.signedMoney || '',
                    client_finish_ratio: this.gridOaOption.data[0]?.clientFinishRatio || '',
                    sign_qty_finish_ratio: this.gridOaOption.data[0]?.signQtyFinishRatio || '',
                  })
                }
              });
            });
            const params = {
              user_bp: this.$store.getters.role.USER_BP,
              mode: type,
              spct_head,
              es_submit,
              ...this.dialogForm,
              audit_comment: this.dialogForm.audit_comment,
              dept_code: this.role.deptCode,
              assign: this.checkAssign,
              ctrfj: this.gridOptionsFile.data,
            }
            const res = await spctOrderPlsp(params)
            if(res.msgtype === 'S'){
              this.gridOptionsFile.data = []
              this.checkAssign = []
              this.dialogForm = {
                main_contont: '',
                audit_comment: '',
                zassign: [],
                assign_bp: '',
              },
              this.showDialog = false
              this.queryData()
              return Message.warning(res.message)
            }else{
              this.loading = false
              return Message.warning(res.message)
            }
          }else{
            this.loading = false
          }
        })
      
    },
    submitVoid(){
      this.gridOaOption.data = []
      this.rules.audit_comment[0].required = true
      this.passArr = []
      const data = this.$refs.xTable.getCheckboxRecords()
      const flag = data.every((item)=>{ return item.order_type === 'ZP01'})
      if(!flag){
        return Message.warning('请选择签约新增单！')
      }
      this.allOrderType = ''
      let noPassArr = []
      data.forEach(ele => {
        if(ele.status === 'E009'){
          this.passArr.push(ele)
        }else{
          noPassArr.push(ele)
        }
      });
      let noPassStr = ''
      if(noPassArr.length){
        noPassArr.forEach(ele => {
          noPassStr += ele.plan_cntr_no + ','
        });
        return Message.warning('单据编号' + noPassStr + '未审批通过或已经提交至OA')
      }
      if(this.passArr.length === data.length){
        this.dialogTitle = '作废'
        this.dialogLable = '作废原因'
        this.showDialog = true
      }
    },
    // 生成OA文件附件并上传服务器 // 批量作废
    async submitHandle(){
      this.loading = true
      const data = this.$refs.xTable.getCheckboxRecords()
      if(this.dialogTitle === '作废'){
        this.saveData('VOID',data)
        return
      }
      if(this.dialogTitle === '批量审批'){
        this.saveData('APPROVE',data)
        return
      }
      this.$refs.form.validate(async(val, err) => {
        if (val){
          const res = await getSendOAFiles(data)
          if(res.data.status === '0'){
            this.loading = false
            return Message.warning('提交失败')
          }
          this.saveData('SUBMIT_OA',data, res.data?.fileList)
        } else {
          this.loading = false
          return Message.warning(this.$utilsCommon.filterErrorMsg(err))
        }
      })
    },
    filterChannel(channel) {
      return channel.map(v => v.chl_name).join(',')
    },
    filterChfl(channel) {
      return channel.map(v => v.value_kt).join(',')
    },
    async queryData(page, ranges) {
      this.dialogForm.audit_comment = ''
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        dept_code: this.role.deptCode,
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.alldialogForm,
        ...this.pagination,
        is_result: 1,
        ...this.allConditions,
        // sort: this.sortData.concat(this.tableSort)
      }
      if(this.sourceType){
        params.status = [{
          "sign": "I",
          "option": "EQ",
          "low": "E009",
          "high": ""
        }]
        params.order_type = [{
          "sign": "I",
          "option": "EQ",
          "low": "ZP01",
          "high": ""
        }]
      }else{
        delete  params.mode
      }
      this.loading = true
      try {
        const { data, button, total, calculation, field } = await getSpct(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.btnLimits = button
        data.forEach((ele,index) => {
          for (const key in ele) {
            if (Object.hasOwnProperty.call(ele, key)) {
              const element = ele[key];
              if(ele[key].indexOf('-')>-1){
                data[index][key] = '-' + ele[key].replace('-', '')
              }
            }
          }
        });
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
        this.getCenterFz({sal_center: this.role.deptCode})
      } catch (e) {
        //
      }
      this.loading = false
    },
    goOrderDetail(row) {
      this.$router.push({
        path: '/wly/qy/sale-plan-edit',
        query: {
          plan_cntr_no: row.plan_cntr_no,
          order_type: row.order_type,
          status: row.status,
        }
      })
    },
    submitCheckedForm(){
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        let selectData
          selectData = this.$refs.xTable.getRadioRecord()
          // selectData = this.$refs.xTable.getCheckboxRecords()
          if (!selectData) {
            return resolve(undefined)
          }
          resolve(selectData)
      })
    },
    // 批量提交OA
    submitOa(){
      this.rules.audit_comment[0].required = true
      this.passArr = []
      this.totalRecomQy = 0
      this.totalRecomPrice = 0
      this.totalRealityQy = 0
      this.totalRealityPrice = 0
      const data = this.$refs.xTable.getCheckboxRecords()
      if(!data.length){
        return Message.warning('请选择提交OA数据！')
      }
      const flag = data.every((item)=>{ return item.sal_center === data[0].sal_center})
      if(!flag){
        return Message.warning('选择的数据不在同一个大区！')
      }
      const flag1 = data.every((item)=>{ return item.chfl === data[0].chfl})
      if(!flag1){
        return Message.warning('选择的数据不属于同一个存货分类！')
      }
      const flag2 = data.every((item)=>{ return item.order_type === data[0].order_type})
      if(!flag2){
        return Message.warning('选择的数据不是同一种单据类型的签约单！')
      }
      this.allOrderType = data[0].order_type
      let noPassArr = []
      let addNum = 0
      let reduceNum = 0
      let bdAddNum = 0
      let baEeduceNum = 0
      let addTotalRealityQy = 0
      let reduceTotalRealityQy = 0
      let addAlocTotalQty = 0
      let reduceAlocTotalQty = 0
      if(data[0].chfl == '0122'){
        data.forEach(ele => {
          if(ele.status === 'E005'){
            this.passArr.push(ele)
            this.totalRecomQy += ele.pre_aloc_plan_qty-0
            this.totalRecomPrice += ele.pre_aloc_plan_amt-0
            this.totalRealityQy += ele.aloc_total_qty-0
            this.totalRealityPrice += ele.total_price-0
            // 八代单独计算
            if(ele.chfl == '0122'){
              if(ele.aloc_total_qty - 0 >= (ele.pre_aloc_plan_qty - 0)*(105/100)){
                bdAddNum += 1
                addTotalRealityQy += ele.pre_aloc_plan_qty-0
                addAlocTotalQty += ele.aloc_total_qty-0
              }
              if(ele.aloc_total_qty - 0 <= (ele.pre_aloc_plan_qty - 0)*(95/100)){
                baEeduceNum += 1
                reduceTotalRealityQy += ele.pre_aloc_plan_qty-0
                reduceAlocTotalQty += ele.aloc_total_qty-0
              }
            }
          }else{
            noPassArr.push(ele)
          }
        });
      }else{
        data.forEach(ele => {
          if(ele.status === 'E005'){
            this.passArr.push(ele)
            this.totalRecomQy += ele.pre_aloc_plan_qty-0
            this.totalRecomPrice += ele.pre_aloc_plan_amt-0
            this.totalRealityQy += ele.aloc_total_qty-0
            this.totalRealityPrice += ele.total_price-0
            if(ele.aloc_total_qty - 0 > ele.pre_aloc_plan_qty - 0){
              addNum += 1
              addTotalRealityQy += ele.pre_aloc_plan_qty-0
              addAlocTotalQty += ele.aloc_total_qty-0
            }
            if(ele.aloc_total_qty - 0 < ele.pre_aloc_plan_qty - 0){
              reduceNum += 1
              reduceTotalRealityQy += ele.pre_aloc_plan_qty-0
              reduceAlocTotalQty += ele.aloc_total_qty-0
            }
          }else{
            noPassArr.push(ele)
          }
        });
      }
      let noPassStr = ''
      if(noPassArr.length){
        noPassArr.forEach(ele => {
          noPassStr += ele.plan_cntr_no + ','
        });
        return Message.warning('单据编号' + noPassStr + '未审批通过或已经提交至OA')
      }
      const  addDiff = addAlocTotalQty - addTotalRealityQy
      const  reduceDiff = reduceTotalRealityQy - reduceAlocTotalQty
      const str = '本次大区申请签约量相比建议签约量增加的客户'+ addNum +'家，增加数量'+ addDiff +'件。相比建议签约量减少的客户'+reduceNum+'家，减少数量'+reduceDiff+'件。'
      const strBd = '本次大区申请签约量相比建议签约量增加5%以上的客户'+ bdAddNum +'家，增加数量'+ addDiff +'件。相比建议签约量减少5%以上的客户'+baEeduceNum+'家，减少数量'+reduceDiff+'件。'
      const suffixContent= data[0].chfl == '0122' ? strBd : str
      const  totalRecomPrices = this.totalRecomPrice.toFixed(2)
      const diffQty = this.totalRealityQy - this.totalRecomQy
      const diffQtyAbs = Math.abs(diffQty)
      const diffQtyDesc = diffQty >= 0 ? '增加' : '减少'
      const diffMoney = (this.totalRealityPrice - this.totalRecomPrice).toFixed(2)
      const diffMoneyAbs = Math.abs(Number(diffMoney)).toFixed(2)
      const diffMoneyDesc = Number(diffMoney) >= 0 ? '增加' : '减少'
      this.dialogForm.main_contont = '本次提报'+ this.passArr.length +'家订单客户的配额计划，建议签约量' + this.totalRecomQy + '件('+
      totalRecomPrices +'万元)，营销大区申请签约量' + this.totalRealityQy + '件(' + 
      this.totalRealityPrice.toFixed(2) + '万元)，大区申请签约总量相比建议签约量' + diffQtyDesc + diffQtyAbs + '件（' + diffMoneyDesc + diffMoneyAbs + '万元）。'+'&nbsp;&nbsp;&nbsp;&nbsp;'+ suffixContent
      this.dialogTitle = '提交OA审批' + '（' + data[0].sal_center_text + '-' + data[0].chfl_text +'）'
      this.dialogLable = '大区意见'
      this.chflText = data[0].chfl_text
      if(this.passArr.length === data.length){
        if(this.allOrderType === 'ZP02'){
          let spike = 0
          let spikeNum = 0
          let decrement = 0
          let decrementNum = -0
          let extension = 0
          let extensionNum = 0
          data.forEach(ele => {
            if(ele.aloc_total_qty - 0 > 0){
              spike += 1
              spikeNum += ele.aloc_total_qty - 0
            }
            if(ele.aloc_total_qty - 0 === 0){
              extension += 1
              extensionNum += ele.aloc_total_qty - 0
            }
            if(ele.aloc_total_qty - 0 < 0){
              decrement += 1
              decrementNum += ele.aloc_total_qty - 0
            }
          });
          decrementNum = decrementNum + ""
          this.dialogForm.main_contont = '本次大区提报'+ spike +'家客户申请计划增量'+spikeNum+'件；'+decrement+'家客户申请减量'+decrementNum.replace('-', '')+'件；'+extension+'家客户计划延期。'
          this.gridOaOption.data = []
          this.showDialog = true
          return
        }
        this.getSaleCenerSignCompleted(data)
      }
    },
    async getSaleCenerSignCompleted(data){
      const params = {
        brand: data[0].chfl,
        saleCenter: data[0].sal_center,
        customerCodes: this.passArr.map(v => v.customer)
      }
      const res = await getSaleCenerSignCompleted(params)
      if(res.status - 0 === 1){
        this.gridOaOption.data = res.data
        if (data[0].chfl === '0102') {
          const invoiceAmount = res.data && res.data.length ? (res.data[0].invoiceAmount - 0) : 0
          const applyQty = this.totalRealityQy - 0
          const applyMoney = (this.totalRealityPrice - 0).toFixed(2)
          const percentCalc = invoiceAmount > 0 ? ((applyQty - invoiceAmount) / invoiceAmount) * 100 : 0
          const increasePercentStr = percentCalc >= 0 ? ('+' + percentCalc.toFixed(2)) : percentCalc.toFixed(2)
          const now = new Date()
          const y = now.getFullYear()
          const m = now.getMonth() + 1
          const endYear = m <= 10 ? y - 1 : y
          let upperCount = 0
          let upperDiffQty = 0
          let lowerCount = 0
          let lowerDiffQty = 0
          console.log(this.passArr)
          this.passArr.forEach(ele => {
            const max = ele.pre_aloc_max_qty - 0
            const min = ele.pre_aloc_min_qty - 0
            const qty = ele.aloc_total_qty - 0
            if (!isNaN(max) && qty > max) {
              upperCount += 1
              upperDiffQty += (qty - max)
            }
            if (!isNaN(min) && qty < min) {
              lowerCount += 1
              lowerDiffQty += (min - qty)
            }
          })
          this.dialogForm.main_contont = `本次提报${this.passArr.length}家订单客户的配额计划，大区申请签约量${applyQty}件(${applyMoney}万元)，同比${endYear}年开票量${increasePercentStr}%。 本次大区申请签约量超过建议签约量上限增加的客户${upperCount}家，超过上限数量${upperDiffQty}件。低于建议签约量下限的客户${lowerCount}家，低于下限签约数量${lowerDiffQty}件。`
        }
        this.showDialog = true
      }
    },
    submitChange(){
      this.gridOaOption.data = []
      const data = this.$refs.xTable.getCheckboxRecords()
      if(!data.length){
        return Message.warning('请选择审核通过的签约新增单！')
      }
      if(data.length.length > 1){
        return Message.warning('请选择一条审核通过的签约新增单！')
      }
      if(data[0].status !== 'E009' || data[0].order_type !== 'ZP01'){
        return Message.warning('请选择审核通过的签约新增单！')
      }
      this.$router.push({
        path: '/wly/qy/sale-plan-change',
        query: {
          plan_cntr_no: data[0].plan_cntr_no,
        }
      })
    },
    // 批量审批
    submitApprove(){
      this.gridOaOption.data = []
      this.rules.audit_comment[0].required = false
      this.allOrderType = ''
      this.passArr = []
      const data = this.$refs.xTable.getCheckboxRecords()
      if(!data.length){
        return Message.warning('请选择审批数据！')
      }
      const flag = data.every((item)=>{ return item.order_type === data[0].order_type})
      if(!flag){
        return Message.warning('选择的数据不是同一种单据类型的签约单！')
      }
      // const flag1 = data.every((item)=>{ return item.chfl === data[0].chfl})
      // if(!flag1){
      //   return Message.warning('选择的数据不属于同一个存货分类！')
      // }
      // this.spct_note = data.some((item)=>{ return item.aloc_total_qty - 0 > (item.plan_qty_23-0)*1.1 || item.aloc_total_qty - 0 < (item.plan_qty_23-0)*0.9}) && this.role.ROLE !== 'WLY002' && data[0].order_type === 'ZP01'
      let noPassArr = []
      data.forEach(ele => {
        const arr = ['E003','E004','E012','E013','E007','E008']
        if(arr.indexOf(ele.status)> -1){
          this.passArr.push(ele)
        }else{
          noPassArr.push(ele)
        }
      });
      let noPassStr = ''
      if(noPassArr.length){
        noPassArr.forEach(ele => {
          noPassStr += ele.plan_cntr_no + ','
        });
        return Message.warning('单据编号' + noPassStr + '当前状态不能审批')
      }
      if(this.passArr.length === data.length){
        this.dialogTitle = '批量审批'
        this.dialogLable = '审核意见'
        this.showDialog = true
        this.getCenterFz(data[0], "YES")
      }
    },
    // 导出全部 导出本页
    async exportExcel() {
      this.gridOaOption.data = []
      const params = {
        dept_code: this.role.deptCode,
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.alldialogForm,
        is_result: 1,
        ...this.allConditions,
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getSpct)
      frontExport(this.gridOptions.columns, data, '销售计划量新增单报表')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  /deep/ .el-textarea{
    .el-textarea__inner{
      color: #333;
    }
  }
  // .oa-table{
  //   margin-bottom: 22px;
  //   width: 848px;
  // }
  /deep/ .el-form-item__label{
    font-size: 14px
  }
  .content_item{
    position: relative;
    .title{
      position: absolute;
      left: -98px;
      top: 38px;
      font-size: 14px;
      color: #666;
      font-weight: 600;
    }
  }
  .uploadBtn {
    display: flex;
    justify-content: end;
  }
  /deep/ .table-button{
    margin-left: 10px;
    height: 40px;
  }
  .classFiles{
    /deep/ .el-form-item__label{
      margin-top: 36px;
    }
  }
  .mainContont{
    line-height: 24px;
    border: 1px solid #DCDFE6;
    padding: 5px;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/qy-manage/salePlanNewList.vue